export const redirect = async (url: string): Promise<void> => {
  setTimeout(() => {
    window.location.href = url;
  }, 1500);
};
